module.exports = {
	title: "ricoh",
	// hostName: "http://192.168.102.210:52297/", //朱敏
	// hostName: "http://192.168.0.134:52297/", //卞san
	// hostName: 'http://192.168.0.126:51197/',//郑炎成
	// hostName: "http://117.71.52.254:21901/", // 测试环境
	hostName: "https://techspace.ricoh.com.cn/api/", //理光正式
};

